
// 隐私协议
export const  USER_PRIVACY_URL = 'https://www.cgtn.com/privacy';
// 使用协议
export const USER_AGREEMENT_URL = 'https://www.cgtn.com/terms-of-use';

// 定义开发环境和正式环境的basename变量
export const BASE_NAME = process.env.NODE_ENV === 'production' ? '/game/wordarena' : '';


// 播放按钮音效的音乐地址
export const PLAY_BUTTON_SOUND_URL = `${BASE_NAME}/common/audio/button.mp3`;
// 游戏胜利音效
export const SUCCESS_SOUND_URL = `${BASE_NAME}/common/audio/success.mp3`;
// 游戏失败音效
export const FAIL_SOUND_URL = `${BASE_NAME}/common/audio/fail.mp3`;
// 游戏enter按键的音效
export const ENTER_SOUND_URL = `${BASE_NAME}/common/audio/enter_music.mp3`;
// 游戏hint按键音效
export const HINT_SOUND_URL = `${BASE_NAME}/common/audio/hint_music.mp3`;
// 游戏键盘按键音效
export const KEYBOARD_SOUND_URL = `${BASE_NAME}/common/audio/keyboard_music.mp3`;
// 游戏字母错误按键音效
export const LETTER_ERROR_SOUND_URL = `${BASE_NAME}/common/audio/letter_error.mp3`;

// 播放背景音乐的地址
export const BACKGROUND_MUSIC_URL = `${BASE_NAME}/common/audio/bgm.mp3`;


// 游客登录时，在leaderboard中显示的一句话
export const VISITOR_LOGIN_LEADERBOARD_TIP = 'Log in to join the leaderboards';